import { Stepper } from './stepper.component';

export * from './stepper.component';
export default Stepper;

Stepper.define('der-ui-stepper');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-stepper': Stepper;
    }
}
